import React from 'react';
import HorizontalStackChart from '../../../../charts/horizontalStackChart';

export const IaksByTypeDistribution = ({ data }) => {
  return (
    data && data.some(item => item.y > 0) &&
    <div className="chart-container">
      <div className="chart-title">IAK-s by Type</div>
      <HorizontalStackChart primaryColor="#fa748d" secondaryColor="#595959" data={data} />
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/charts/iaksByTypeDistribution.js